.tooltipWrapper {
  >button:first-child {
    padding: 0rem !important;
    min-width: 27px !important;

    >span>svg {
      fill: #333;
    }
  }

  >div:nth-child(2) {
    
    >div:nth-child(2) {
      font-weight: 400;
      padding: 0.4rem !important;
      line-height: 1.7rem;
      width: 500px;
    }
  }
}